import { FormQuestionType } from '../../../../../Services/Constants/FormQuestionType';
import { Type } from 'class-transformer';
import { DynamicForm as DynamicForm1 } from './OptionInfo';
import { DynamicForm as DynamicForm2 } from './AnswerInfo';

export class QuestionInfo {
	Id: number;
	ParentId: number;
	SortValue: number;
	Alias: string;
	Required: boolean;
	@Type(() => DynamicForm1.OptionInfo)
	Options: Array<DynamicForm1.OptionInfo>;
	Header: string;
	Description: string;
	TrueDescriptor: string;
	FalseDescriptor: string;
	Placeholder: string;
	Type: FormQuestionType;
	@Type(() => DynamicForm2.AnswerInfo)
	Answer: DynamicForm2.AnswerInfo | undefined;

	// Spa specific
	questionNumber: number;
}
